module.exports = __webpack_public_path__ + "img/3.dc2d1715.jpg";